import {Pagination} from "@adminComponents";
import {IPage} from "@adminData";
import React from "react";
import styles from "./style.module.scss";

interface IProps {
  children: JSX.Element | JSX.Element[];
  paging?: IPage;
  getList?: ({page}: {page: number}) => void;
}

export default function ListTable({children, paging, getList}: IProps) {
  return (
    <div className={styles.container}>
      <table className={styles.table}>{children}</table>
      {!!paging && paging.maxpage > 1 && (
        <Pagination paging={paging} getList={getList} />
      )}
    </div>
  );
}
